import BaseCommand from "@/models/api/commands/BaseCommand";

export class OrderItemMoveToPositionCommandParams {
  OrderItemGuid!: string;
  PositionToSet!: number;
}

export class OrderItemMoveToPositionCommand extends BaseCommand {
  CommandName = "OrderItemMoveToCommand";
  Command: { OrderItemGuid: string; PositionToSet: number };
  constructor(sessionId: string, operationId: string, param: OrderItemMoveToPositionCommandParams) {
    super(sessionId, operationId);
    this.Command = param;
  }
}
